import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Button } from '../components/ui/button';
import { useDocumentTitle } from '../hooks/use-document-title';

// Pill buttons: ink for the main action, thin gradient outline for the rest.
const PILL = 'h-11 rounded-full px-5 text-sm font-bold';
const PILL_INK = `${PILL} bg-ink text-paper hover:bg-ink/90`;
const PILL_OUTLINE = `${PILL} gradient-border text-ink shadow-none hover:[--gb-bg:#F2F0EB]`;

export default function CheckoutCancelPage() {
  useDocumentTitle('Payment cancelled');

  return (
    <div className="min-h-screen bg-paper">
      <Navbar />
      <main id="main-content" className="relative min-h-screen flex items-center justify-center px-4 sm:px-6 pt-28 pb-16 overflow-hidden">
        <div aria-hidden="true" className="pointer-events-none absolute inset-0">
          <div className="glow-pink absolute -top-24 -left-24 h-[26rem] w-[26rem] sm:left-[12%] sm:top-[10%] opacity-60" />
          <div className="glow-blue absolute -bottom-32 -right-24 h-[28rem] w-[28rem] sm:right-[10%] sm:bottom-[6%] opacity-60" />
        </div>
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="relative w-full text-center max-w-md gradient-border gb-glass backdrop-blur-sm rounded-[28px] shadow-[0_30px_60px_-36px_rgba(26,26,26,0.35)] p-8 sm:p-10"
        >
          <div className="w-20 h-20 bg-[#EEEBE4] rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="h-10 w-10 text-[#4A4640]" aria-hidden="true" />
          </div>
          <h1 className="font-serif text-3xl font-semibold tracking-tight text-ink mb-3">Payment cancelled</h1>
          <p className="text-[#4A4640] leading-relaxed mb-8">
            No charges were made. Your items are still in your cart whenever you're ready.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button asChild className={PILL_INK}>
              <Link to="/cart" data-testid="back-to-cart">Return to cart</Link>
            </Button>
            <Button asChild variant="ghost" className={PILL_OUTLINE}>
              <Link to="/dashboard" data-testid="back-to-dashboard">My Invitations</Link>
            </Button>
          </div>
        </motion.div>
      </main>
    </div>
  );
}
